import { useTransition } from '@react-spring/web';
import { SearchItem } from '../../../types/types';

export const useAnimatedSearchItems = (items: SearchItem[]) => {
  const transitions = useTransition(items, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    update: { opacity: 1 },
    config: {
      tension: 300,
      friction: 30,
    },
  });

  return transitions;
};
